import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import { configureCleanReducer, configureSyncReducer, TileAction, TileId } from '@contact/upgrade';

import * as fromDomain from './domain';
import * as fromSystem from './system';

/**
 * Name store feature
 */
export const featureName = 'engagement';

/**
 * Engagement state interface
 */
export interface EngagementState {
  domain: fromDomain.Domain;
  system: fromSystem.EngagementSystem;
}

/**
 * Initial Engagement state
 */
export const initialState: EngagementState = {
  domain: fromDomain.initialDomain,
  system: fromSystem.initialEngagementSystem,
};

/**
 * Engagement reducers map
 */
export const reducers: ActionReducerMap<EngagementState> = {
  domain: fromDomain.reducer,
  system: fromSystem.reducer,
};

const cleanReducer = configureCleanReducer(featureName, {
  initialState,
  keys: [],
  cleanPredicate: action => action.type === TileAction.Reset.type && action.tileId === TileId.ENGAGEMENT,
});
const syncReducer = configureSyncReducer(featureName, []);

/**
 * Core meta reducers array
 */
export const metaReducers = [cleanReducer, syncReducer];

/**
 * Memoized selector for Engagement model
 */
const getFeature = createFeatureSelector<EngagementState>(featureName);
export const getDomain = createSelector(getFeature, (state: EngagementState) => state.domain);
export const getDomainUuid = createSelector(getDomain, fromDomain.getDomainUuid);

export const getSystem = createSelector(getFeature, (state: EngagementState) => state.system);

export const isDomainLoaded = createSelector(getSystem, fromSystem.isDomainLoaded);

/**
 * Memoized selector for global model
 */
export const isEngagementReady = createSelector(isDomainLoaded, configLoaded => configLoaded);
